<template>
  <QItem class="q-my-md bg-white rounded-borders feedback-candidate-list-item" :class="candidate.isRecruited() ? 'feedback-candidate-recruited' : ''">
    <QItemSection avatar>
      <Avatar :picture="candidate.getPicture()" size="50px" />
      <span v-if="candidate.isFavorite()" class="extra-favorite"><QIcon name="favorite" /></span>
    </QItemSection>

    <QItemSection>
      <QItemLabel>
        <p class="q-ma-none">
          <span class="text-weight-bold">
            {{ candidate.getFirstname() }}
          </span>
          <span v-if="!isSmallScreen" class="text-weight-bold">
            {{ candidate.getLastname() }}
          </span>
          <span v-if="isSmallScreen" class="text-weight-bold">
            {{ candidate.getLastnameInitials() }}
          </span>
        </p>
        <span v-if="candidate.getPostalCode()" class="recruitment-candidate-card-postal-code font-085">{{ candidate.getPostalCode() }}</span>
      </QItemLabel>
      <QItemLabel caption>
        <QBtn v-if="candidate.getPhone()" dense flat icon="icon-f-phone" size="sm" class="q-mr-xs" style="top: -3px" @click.stop="callCandidate">
          <QTooltip v-if="!isSmallScreen" content-style="font-size:0.85em;" anchor="center right" self="center middle" content-class="bg-black">
            {{ formattedPhoneNumber }}
          </QTooltip>
        </QBtn>
        <QBtn dense flat icon="icon-f-mail" size="sm" style="top: -3px" @click.stop="emailCandidate" />
      </QItemLabel>
    </QItemSection>

    <QItemSection side>
      <QItemLabel lines="1">
        <span class="recruitment-candidate-card-jobs">
          {{ $tc("ETAB.PAGES.CANDIDATE.CARD.@JOBS", candidate.getExperiencesAmount()) }}
        </span>
      </QItemLabel>
      <QItemLabel>
        <template v-if="candidate.getAverageNote() > 0">
          <StarsNotationComponent :note="candidate.getAverageNote()" :notes-amount="candidate.getNotesAmount()" />
        </template>
      </QItemLabel>
    </QItemSection>
    <div v-if="candidate.isRecruited()" class="list-item-btns">
      <QBtn
        dense
        class="no-pointer-events"
        no-caps
        unelevated
        text-color="positive"
        icon="check"
        :label="$t('ETAB.PAGES.CANDIDATE.CARD.@RECRUITED')"
      />
      <QBtn
        dense
        no-caps
        unelevated
        text-color="negative"
        :icon="isSmallScreen ? undefined : 'close'"
        :label="$t('ETAB.PAGES.CANDIDATE.CARD.@CTA_NOT_RECRUITED')"
        @click="recruitedCandidate(false)"
      />
    </div>
    <div v-else class="list-item-btns">
      <QBtn
        v-if="hasRecruited"
        dense
        no-caps
        unelevated
        size="md"
        text-color="primary"
        icon="handshake"
        :label="$t('ETAB.PAGES.CANDIDATE.CARD.@CTA_RECRUITED')"
        @click="recruitedCandidate(true)"
      />
      <QBtn
        dense
        no-caps
        unelevated
        size="md"
        text-color="negative"
        icon="report_problem"
        :label="$t('ETAB.PAGES.CANDIDATE.CARD.@REPORT_CANDIDATE')"
        @click="openReportCandidateModal"
      />
    </div>
  </QItem>
</template>

<script>
  import { FeedbackCandidateModel, RecruitmentDefaultModel } from "@core/models";
  import { JavascriptHelpers } from "@core/helpers";

  import StarsNotationComponent from "@core/components/common/StarsNotation.component.vue";

  export default {
    components: {
      StarsNotationComponent,
    },
    props: {
      hasRecruited: {
        type: Boolean,
        default: () => false,
      },
      candidate: {
        type: Object,
        default: () => new FeedbackCandidateModel(),
      },
      recruitment: {
        type: Object,
        default: () => new RecruitmentDefaultModel(),
      },
      showExperience: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["onRecruitedCandidate", "reportCandidate", "openReportModal", "callCandidate", "emailCandidate"],
    computed: {
      formattedPhoneNumber() {
        return JavascriptHelpers.formatPhoneNumber(this.candidate.getPhone());
      },
      isSmallScreen() {
        return this.$q.screen.lt.md;
      },
    },
    methods: {
      recruitedCandidate(isRecruited = true) {
        this.$emit("onRecruitedCandidate", { candidate: this.candidate, demand: this.recruitment, recruited: isRecruited });
      },
      reportCandidate() {
        this.$emit("reportCandidate", { candidate: this.candidate });
      },
      openReportCandidateModal() {
        this.$emit("openReportModal", { candidate: this.candidate });
      },
      callCandidate() {
        this.$emit("callCandidate", { candidate: this.candidate });
      },
      emailCandidate() {
        this.$emit("emailCandidate", { candidate: this.candidate });
      },
    },
  };
</script>

<style lang="scss">
  .feedback-candidate-list-item {
    box-shadow: $card-shadow;
    padding-bottom: 70px;

    &.feedback-candidate-recruited {
      border-left: 15px solid $positive;
    }

    .extra-favorite {
      position: absolute;
      top: 0;
      left: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      text-align: center;
      font-size: 20px;
      background-color: white;
      color: $secondary;
    }

    .not-recruited-link {
      font-size: 0.7rem;
      margin-right: 4px;
    }

    .list-item-btns {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 60px;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: stretch;
      border-top: 1px solid rgba($primary, 0.1);

      button {
        width: 50%;
        border-radius: 0 3px 3px 0;
        box-shadow: none;
        &:nth-child(2) {
          border-left: 1px solid rgba($primary, 0.1);
        }
      }
    }
  }
</style>
